import { ComboBox } from "../../wspolne/comboBox";

export class ImportujEwidencjeRezultat {
    listaBledow: Array<string> = new Array();
    listaKolumn: Array<string> = new Array();
    listaKolumnLokalizacji: Array<string> = new Array();
    listaPolSpisu: Array<ComboBox> = new Array();

}